import React, { useContext } from "react";
import styles from "@/page-components/taggings/tagging.module.css";
import addWidget from "@/assets/img/addWidget.svg";
import { ReportingContext } from "../reporting-context-file";
import CreateReport from "./create-report-form";

const ReportingHeading = ({
  service,
  deleteError,
  deleteSuccess,
  deleteLoading,
  deleteData,
}) => {
  const context = useContext(ReportingContext);

  return (
    <>
      <div className={styles.headerSectionTextP}>
        {context?.SelectedTab === "Reporting Center" ? (
          <div className={styles.headerSection}>
            <span className={styles.costText}>Reporting Center</span>
            <span className={styles.costTextp}>
              Generate, schedule, and manage your cloud cost reports
            </span>
          </div>
        ) : (
          <div className={styles.headerSection}>
            <span className={styles.costText}>Reports Library</span>
            <span className={styles.costTextp}>
              Generate, schedule, and manage your cloud cost reports
            </span>
          </div>
        )}
        {context?.SelectedTab === "Reporting Center" && (
          <div
            className=" btn add_new_widgets"
            onClick={() => {
              context?.setIsLayoverOpen(true);
            }}
          >
            <img className="add_widgte_svg" src={addWidget} alt=" " />
            <span className="add_widget_text">Create Report</span>
          </div>
        )}
      </div>
      <CreateReport
        service={service}
        deleteError={deleteError}
        deleteSuccess={deleteSuccess}
        deleteLoading={deleteLoading}
        deleteData={deleteData}
      />
    </>
  );
};

export default ReportingHeading;
